module.exports = __webpack_public_path__ + "static/media/IMG_3503_sm.fedb390e.jpg";